import { StyledNumbersCard } from "@/components/styles";

export default function NumbersCard({ number, text }) {
  return (
    <StyledNumbersCard>
      <StyledNumbersCard.Number> {number}</StyledNumbersCard.Number>
      <StyledNumbersCard.Text>{text}</StyledNumbersCard.Text>
    </StyledNumbersCard>
  );
}
